/**
 * Castle & Key Age Gate
 * Shows a full-screen overlay until the visitor confirms they are 21+.
 * Stores consent in a cookie for 30 days.
 */
(function () {
  var COOKIE_NAME = 'ck_age_verified';
  var COOKIE_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
  }

  var gate = document.getElementById('ck-age-gate');
  if (!gate) return;

  // Already verified — leave gate hidden
  if (getCookie(COOKIE_NAME) === 'true') return;

  // Not verified — show gate
  gate.removeAttribute('hidden');
  document.body.classList.add('ck-age-gate-active');

  var stateSelect = document.getElementById('ck-age-gate-state');
  var stateError = gate.querySelector('.ck-age-gate__state-error');

  gate.querySelector('[data-age-gate-yes]').addEventListener('click', function () {
    // Require state selection
    if (!stateSelect || !stateSelect.value) {
      if (stateError) stateError.classList.remove('ck-age-gate__state-error--hidden');
      if (stateSelect) stateSelect.focus();
      return;
    }
    if (stateError) stateError.classList.add('ck-age-gate__state-error--hidden');

    setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);

    // Save selected state for BottleNexus compliance
    try {
      localStorage.setItem('bn_state', stateSelect.value);
      localStorage.setItem('bn_state_ts', String(Date.now()));
      document.dispatchEvent(new CustomEvent('bn:context:changed', {
        detail: { state: stateSelect.value, source: 'age-gate' }
      }));
    } catch (e) {}

    gate.hidden = true;
    document.body.classList.remove('ck-age-gate-active');
  });

  // Clear error when state is selected
  if (stateSelect) {
    stateSelect.addEventListener('change', function () {
      if (stateSelect.value && stateError) {
        stateError.classList.add('ck-age-gate__state-error--hidden');
      }
    });
  }

  gate.querySelector('[data-age-gate-no]').addEventListener('click', function () {
    gate.querySelector('.ck-age-gate__actions').style.display = 'none';
    gate.querySelector('.ck-age-gate__denied').classList.remove('ck-age-gate__denied--hidden');
  });
})();
